import { forwardRef } from 'react';
import TextInternal from './text-internal';
const Text = forwardRef(TextInternal);
export default Text;
